module.exports = __webpack_public_path__ + "static/media/gold.cac0ced4.png";